'use client';

import {
  PropsWithChildren,
  CSSProperties,
  useState,
  useEffect,
  useTransition,
} from 'react';
import { clsx } from 'clsx';

import { useScrollProgress } from '@monoimin/hooks';

export type ScrollSensitiveContainerProps = PropsWithChildren<{
  start?: number;
  as?: keyof JSX.IntrinsicElements;
  style?: CSSProperties;
  className?: string;
  withTriggerClasses?: string;
  withoutTriggerClasses?: string;
  debounceDelay?: number;
}>;

export const ScrollSensitiveContainer = ({
  start = 0,
  as = 'div',
  style,
  className,
  withTriggerClasses,
  withoutTriggerClasses,
  children,
  debounceDelay,
}: ScrollSensitiveContainerProps) => {
  const isTrigger = useScrollProgress({ start, debounceDelay });
  const [, startTransition] = useTransition();
  const [triggerClassName, setTriggerClassName] = useState<string | undefined>(
    withoutTriggerClasses
  );

  const Root = as;

  useEffect(() => {
    // Use transition to mark this UI update as non-urgent
    startTransition(() => {
      if (isTrigger) {
        setTriggerClassName(withTriggerClasses);
      } else {
        setTriggerClassName(withoutTriggerClasses);
      }
    });
  }, [isTrigger, withTriggerClasses, withoutTriggerClasses]);

  return (
    <Root style={style} className={clsx(className, triggerClassName)}>
      {children}
    </Root>
  );
};

export default ScrollSensitiveContainer;
